<!-- 标签管理-->
<template>
  <div>
    <x-tabula
      ref="table"
      apiOrigin="PHP"
      :dataSource="dataSource"
      rowKey="tag_id"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptLen="4"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :deleteParam="deleteParam"
      :listApi="listApi"
      :rowSelection="false"
    >
    </x-tabula>
    <!-- 编辑标签 -->
    <a-modal
      :title="moduleTitle"
      :visible="visible"
      :footer="null"
      @cancel="visible=false"
      :confirmLoading="btnLoading.loading"
      v-bind="this.$store.state.modalConfig"
    >
    <x-addEdit
      ref="form"
      apiOrigin="PHP"
      :formList="formList"
      :formKey="formKey"
      :addParam="addParam"
      :editParam="editParam"
      :detailParam="detailParam"
    >
    </x-addEdit>
    </a-modal>
  </div>
</template>

<script>
import { addEdit } from 'ant-design-vue-admin-x';
export default {
  name: 'labelManage',
  mixins: [addEdit],
  data () {
    return {
      visible: false,
      moduleTitle: '新建标签',
      btnLoading: { loading: false },
      searchList: [
        { props: ['keywords'], placeholder: '标签名', options: [], inputType: 'input' }
      ],
      tableOptList: [
        { text: '新增', handle: () => this.openModel(), permi: ['community:labelManage:add'] }
      ],
      rowOptList: [
        { text: '编辑', handle: (row) => this.openModel(row), permi: ['community:labelManage:add'] },
        { text: '删除', handle: (row) => this.$refs.table.showDeleteConfirm(row), permi: ['community:labelManage:add'] }
      ],
      columns: [
        { title: '标签名', dataIndex: 'title', align: 'left', width: '' },
        { title: '权重', dataIndex: 'weight', align: 'left', width: '' },
        { title: '创建人', dataIndex: 'create_user_name', align: 'left', width: '' },
        { title: '创建时间', dataIndex: 'create_time', align: 'left', width: '' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      searchParams: {
        keywords: undefined
      },
      listApi: {
        url: '/live/tags', // live/applys
        resHandle: this.resHandle, // this.resHandle
        searchHandle: '' // searchHandle
      },
      deleteParam: {
        url: '/live/tags',
        param: { pk_key: 'tag_id', pk_val: '' },
        title: '标签名',
        key: 'title'
      },
      formList: [
        {
          label: '标签名称',
          inputType: 'input',
          options: [],
          placeholder: '请输入签名称',
          props: ['title', {
            rules: [
              { required: true, message: '请输入签名称' },
              { max: 4, message: '标签名不超过四个字' }
            ]
          }]
        },
        {
          label: '权重',
          inputType: 'input',
          options: [],
          placeholder: '请输入权重',
          props: ['weight', {
            rules: [
              { required: true, message: '请输入权重' }
            ]
          }]
        },
        {
          label: '推荐页置顶',
          inputType: 'switch',
          handle: this.switchHandle,
          options: [],
          placeholder: '',
          props: ['is_top', {
            initialValue: 0
          }]
        },
        {
          isShow: false,
          label: '图标',
          inputType: 'upload',
          options: [],
          placeholder: '',
          extra: '请上传N*N的图标，此图标将展示在直播封面的左上角，不超过2MB',
          fileList: [],
          uploadParam: {
            url: '/oss_upload/3',
            iconUrl: 'top_image',
            iconName: 'file_name',

            action: this.$store.state.uploadUrl,
            accept: this.$store.state.imgAccept,
            listType: 'picture'
          },
          props: ['file_id', {
            rules: [{required: true, message: '请选择上传图标'}]
          }]
        }
      ],
      formKey: {
        title: '',
        weight: '',
        is_top: '',
        file_id: ''
      },
      // 表单参数
      addParam: {
        url: '/live/tags',
        reqHandle: this.editReqHandle, // this.reqHandle
        resHandle: this.addResHandle
      },
      editParam: {
        url: '/live/tags/',
        reqHandle: this.editReqHandle,
        resHandle: this.addResHandle
      },
      detailParam: {
        url: '', // /room/
        resHandle: this.detailResHandle
      }
    };
  },
  mounted () {
  },
  methods: {
    openModel (row) {
      this.visible = true;
      if (!row.is_top) {
        this.$nextTick(() => {
          this.removeFile('file_id');
        });
      } else {
        this.formList[3].isShow = true;
      }
      if (row && row.tag_id) {
        this.moduleTitle = '编辑标签';
        this.detailParam.url = `/live/tags/${row.tag_id}`;
        this.$nextTick(() => {
          this.$refs.form.getDetail();
          this.$refs.form.routeQuery = row.tag_id;
        });
      } else {
        this.moduleTitle = '新建标签';
      }
    },
    switchHandle (e) {
      if (e) {
        this.formList[3].isShow = true;
        this.$nextTick(() => {
          this.removeFile('file_id');
        });
      } else {
        this.formList[3].isShow = false;
      }
    },
    editReqHandle (res) {
      if (res.is_top) {
        res.is_top = 1;
        if (Array.isArray(res.file_id.fileList)) {
          if (!res.file_id.fileList.length) {
            this.$message.error('请先上传图标');
          } else {
            return res;
          }
        } else {
          if (res.file_id) {
            return res;
          } else {
            this.$message.error('请先上传图标');
          }
        }
      } else {
        res.is_top = 0;
        delete res.file_id;
        return res;
      }
    },
    addResHandle (res) {
      if (res.code === 1) {
        this.visible = false;
        this.$message.success(res.msg);
        this.$refs.table.getTableList();
        this.formList[3].isShow = false;
      } else {
        this.$message.error(res.msg);
      }
    },
    detailResHandle (res) {
      if (res.is_top) {
        this.$refs.form.isChecked = true;
        this.formList[3].isShow = true;
      } else {
        this.$refs.form.isChecked = false;
        this.formList[3].isShow = false;
      }
      return res;
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      // return selectData;
    }
  }
};
</script>
